
{
  "familyId": "STU-BIBLIOTHEEK",
  "questions": [
    {
      "id": "STU-BIBLIOTHEEK-001",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "multiple_choice",
      "question": "In de bibliotheek staan boeken geordend op categorie. Waar vind je een boek over vulkanen?",
      "options": ["Bij de non-fictie / informatieve boeken", "Bij de romans", "Bij de stripboeken", "Bij de poëzie"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Fictie vs non-fictie", "content": "Non-fictie = informatieve boeken over echte onderwerpen (natuur, geschiedenis, wetenschap). Fictie = verzonnen verhalen (romans, sprookjes). Een boek over vulkanen is non-fictie.", "icon": "lightbulb" } }],
      "conceptId": "bieb_fictie_nonfictie",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Een boek over vulkanen gaat over een echt onderwerp → dat is non-fictie (informatief). Romans zijn verzonnen verhalen, stripboeken zijn getekende verhalen, en poëzie zijn gedichten.",
        "solutionSteps": ["Vulkanen = echt onderwerp", "Echt onderwerp = non-fictie / informatief", "Non-fictie staat apart van fictie (romans)"],
        "distractorExplanations": {
          "0": "Goed! Een boek over vulkanen is non-fictie en staat bij de informatieve boeken.",
          "1": "Je dacht waarschijnlijk dat alle boeken bij de romans staan. Maar romans zijn verzonnen verhalen (fictie). Een boek over vulkanen is geen verzonnen verhaal maar een informatief boek (non-fictie). Onthoud: echt onderwerp = non-fictie.",
          "2": "Je dacht waarschijnlijk dat stripboeken ook informatief kunnen zijn. Hoewel er informatieve strips bestaan, staat een standaard informatief boek over vulkanen bij de non-fictie afdeling. Onthoud: non-fictie = informatieve boeken.",
          "3": "Je dacht waarschijnlijk dat poëzie breed is. Maar poëzie zijn gedichten en dichtbundels. Een informatief boek over vulkanen staat bij non-fictie. Onthoud: poëzie = gedichten."
        }
      }
    },
    {
      "id": "STU-BIBLIOTHEEK-002",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "ordering",
      "question": "Sorteer deze schrijvers alfabetisch op achternaam (tussenvoegsels tellen niet mee).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Anna de Jong",
          "Tom Bakker",
          "Lisa van der Berg",
          "Sam de Vries",
          "Eva van Dijk"
        ],
        "correctOrder": [1, 2, 4, 0, 3]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Alfabetisch op achternaam", "content": "Kijk alleen naar de achternaam. Tussenvoegsels zoals 'de', 'van' en 'van der' tellen niet mee. Bakker (B), Berg (B-e), Dijk (D), Jong (J), Vries (V).", "icon": "lightbulb" } }],
      "conceptId": "bieb_catalogus_naam",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "In de bibliotheek sorteer je op achternaam zonder tussenvoegsels. Bakker (B), Berg (B-e), Dijk (D), Jong (J), Vries (V). Let op: Bakker komt voor Berg omdat de 'a' voor de 'e' komt.",
        "solutionSteps": [
          "Negeer de voornamen en tussenvoegsels",
          "De achternamen zijn: Jong, Bakker, Berg, Vries, Dijk",
          "Sorteer alfabetisch: Bakker, Berg, Dijk, Jong, Vries"
        ]
      }
    },
    {
      "id": "STU-BIBLIOTHEEK-003",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "multiple_choice",
      "question": "Wat is het NUR-nummer op een bibliotheekboek?",
      "options": ["Een code die aangeeft in welke categorie het boek hoort", "Het aantal pagina's", "Het jaar van uitgave", "De prijs van het boek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "NUR-code", "content": "NUR staat voor Nederlandstalige Uniforme Rubrieksindeling. Het is een nummer dat aangeeft in welke categorie een boek hoort (bijv. 280 = kinderboeken, 300 = informatief).", "icon": "lightbulb" } }],
      "conceptId": "bieb_nur_code",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Het NUR-nummer (Nederlandstalige Uniforme Rubrieksindeling) is een categoriecode. Het helpt bibliotheken om boeken in te delen, bijvoorbeeld: kinderboeken, informatief, romans, etc.",
        "solutionSteps": ["NUR = Nederlandstalige Uniforme Rubrieksindeling", "Het is een categoriecode", "Helpt bij het indelen en terugvinden van boeken"],
        "distractorExplanations": {
          "0": "Goed! Het NUR-nummer is een categoriecode voor het indelen van boeken.",
          "1": "Je dacht waarschijnlijk dat NUR het aantal pagina's aangeeft. Maar het aantal pagina's staat apart vermeld in de publicatiegegevens, niet als NUR-nummer. Onthoud: NUR = categorie, niet omvang.",
          "2": "Je dacht waarschijnlijk dat NUR het jaar van uitgave is. Maar het jaar staat bij de publicatiegegevens (bijv. '© 2024'). Het NUR-nummer is een categoriecode. Onthoud: NUR = categorie, niet datum.",
          "3": "Je dacht waarschijnlijk dat NUR de prijs aangeeft. Maar de prijs staat op de achterkant of in de boekhandel. Het NUR-nummer helpt bibliotheken bij het indelen. Onthoud: NUR = categorie, niet prijs."
        }
      }
    },
    {
      "id": "STU-BIBLIOTHEEK-004",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "multiple_choice",
      "question": "Je wilt weten of de bibliotheek een bepaald boek heeft. Wat doe je het snelst?",
      "options": ["Zoeken in de online catalogus", "Alle schappen langslopen", "Aan een vriend vragen", "Op internet zoeken naar het boek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Zoeken in de bibliotheek", "content": "De online catalogus van de bibliotheek laat zien welke boeken beschikbaar zijn, waar ze staan, en of ze uitgeleend zijn. Dat is veel sneller dan zelf zoeken.", "icon": "lightbulb" } }],
      "conceptId": "bieb_zoeken",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.82,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De online catalogus is de snelste manier. Je typt de titel of schrijver in en ziet meteen of het boek beschikbaar is en waar het staat.",
        "solutionSteps": ["Online catalogus → zoek op titel of schrijver", "Je ziet meteen of het boek er is", "Je ziet ook waar het staat in de bibliotheek"],
        "distractorExplanations": {
          "0": "Goed! De online catalogus is de snelste en meest betrouwbare manier.",
          "1": "Je dacht waarschijnlijk dat zelf zoeken net zo snel is. Maar alle schappen langslopen kost veel tijd en je kunt het boek missen als het verkeerd teruggeplaatst is. Onthoud: de catalogus is sneller en betrouwbaarder.",
          "2": "Je dacht waarschijnlijk dat een vriend het weet. Maar een vriend weet waarschijnlijk niet welke boeken jouw bibliotheek precies heeft. Onthoud: de catalogus is de officiële bron.",
          "3": "Je dacht waarschijnlijk dat internet helpt. Op internet vind je informatie óver het boek, maar niet of jouw specifieke bibliotheek het heeft en of het beschikbaar is. Onthoud: bibliotheek-catalogus ≠ Google."
        }
      }
    },
    {
      "id": "STU-BIBLIOTHEEK-005",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "fill_in",
      "question": "In de bibliotheek staan boeken op achternaam. Zet de schrijver 'De Vries' bij de juiste letter. Typ alleen de letter.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["V", "v"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tussenvoegsel", "content": "'De' is een tussenvoegsel. De achternaam is 'Vries'. Zoek bij de V.", "icon": "lightbulb" } }],
      "conceptId": "bieb_catalogus_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "'De Vries' → 'De' is het tussenvoegsel, 'Vries' is de achternaam. In de catalogus zoek je op achternaam → letter V.",
        "solutionSteps": ["'De' = tussenvoegsel (telt niet mee)", "'Vries' = achternaam", "Zoek bij de letter V"]
      }
    },
    {
      "id": "STU-BIBLIOTHEEK-006",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "matching",
      "question": "Koppel de bibliotheek-term aan de juiste uitleg.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Catalogus", "right": "Lijst van alle boeken in de bibliotheek" },
          { "left": "NUR-code", "right": "Nummer dat de categorie van een boek aangeeft" },
          { "left": "Fictie", "right": "Verzonnen verhalen zoals romans" },
          { "left": "Non-fictie", "right": "Informatieve boeken over echte onderwerpen" },
          { "left": "Uitleentermijn", "right": "De tijd dat je een boek mag houden" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Bibliotheek-termen", "content": "Catalogus = boekenlijst. NUR-code = categorie. Fictie = verzonnen. Non-fictie = informatief/echt. Uitleentermijn = hoe lang je mag lenen.", "icon": "lightbulb" } }],
      "conceptId": "bieb_termen_matching",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "Fictie is verzonnen (romans), non-fictie is echt (informatief). De catalogus is het zoeksysteem. De NUR-code is de categorie. De uitleentermijn bepaalt wanneer het boek terug moet.",
        "solutionSteps": [
          "Lees de term en zoek de best passende uitleg",
          "Fictie = verzonnen, Non-fictie = echt/informatief",
          "Catalogus = lijst/zoeksysteem",
          "Uitleentermijn = tijd dat je mag lenen"
        ]
      }
    },
    {
      "id": "STU-BIBLIOTHEEK-007",
      "familyId": "STU-BIBLIOTHEEK",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "informatie",
      "subSkill": "info_bibliotheek",
      "questionType": "ordering",
      "question": "Zet de stappen om een boek in de bibliotheek te vinden in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Bedenk wat je zoekt (titel, schrijver of onderwerp)",
          "Zoek in de online catalogus",
          "Noteer de plaatsingscode",
          "Loop naar de juiste afdeling",
          "Zoek het boek op de plank op de plaatsingscode"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Boek zoeken", "content": "Eerst bedenken wat je zoekt, dan in de catalogus kijken. Noteer de code, loop naar de afdeling en zoek het boek op de plank.", "icon": "lightbulb" } }],
      "conceptId": "bieb_zoekstappen_ordering",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "De juiste volgorde: 1) Bedenk wat je zoekt, 2) Zoek in de catalogus, 3) Noteer de plaatsingscode, 4) Loop naar de afdeling, 5) Zoek op de plank. Zonder de code weet je niet waar je moet zoeken!",
        "solutionSteps": [
          "1. Bedenk wat je zoekt",
          "2. Zoek in de online catalogus",
          "3. Noteer de plaatsingscode",
          "4. Loop naar de juiste afdeling",
          "5. Zoek het boek op de plank"
        ]
      }
    }
  ]
}
